import React from 'react';
import { Map as LeafletMap, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import markerGuto from 'assets/img/marker-guto.png';
import 'leaflet/dist/leaflet.css';

let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

// Ícone customizado para caminhão usando marker-guto.png
const VehicleIcon = L.icon({
  iconUrl: markerGuto,
  iconSize: [40,40],
  iconAnchor: [16, 16],
  popupAnchor: [0, -16],
});

L.Marker.prototype.options.icon = DefaultIcon;

export const MapConvocation = ({ trips = [], trackingData = [] }) => {
  // Coordenadas do centro do Brasil
  const centerBrasil = [-14.2350, -51.9253];

  // Limites restritivos do território brasileiro (apenas Brasil, sem países vizinhos)
  const maxBounds = [
    [4.5, -74.0], // Sudoeste (canto inferior esquerdo)
    [-33.5, -34.0] // Nordeste (canto superior direito)
  ];

  // Debug: Log dos dados de rastreamento
  React.useEffect(() => {
    console.log('🔍 [MapConvocation] trackingData atualizado:', {
      length: trackingData?.length || 0,
      data: trackingData,
      isArray: Array.isArray(trackingData),
    });
    if (trackingData && trackingData.length > 0) {
      console.log('🚚 [MapConvocation] Dados de rastreamento recebidos:', trackingData.length, trackingData);
      trackingData.forEach((track, idx) => {
        console.log(`  [${idx}] Carga ID: ${track.carga_id}, Lat: ${track.latitude || track.lat}, Lng: ${track.longitude || track.lng}`);
      });
    } else {
      console.log('⚠️ [MapConvocation] Nenhum dado de rastreamento recebido ou array vazio');
    }
  }, [trackingData]);

  return (
    <LeafletMap
      center={centerBrasil}
      zoom={5}
      minZoom={4}
      maxZoom={18}
      maxBounds={maxBounds}
      maxBoundsViscosity={1.0}
      style={{ height: '100%', width: '100%' }}
      scrollWheelZoom={true}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {/* Marcadores de Rastreamento (Última Posição do Veículo) */}
      {trackingData && trackingData.length > 0 && trackingData.map((track, index) => {
        // Tentar diferentes formatos de latitude/longitude
        const lat = parseFloat(track.latitude || track.lat || 0);
        const lng = parseFloat(track.longitude || track.lng || 0);

        // Validar coordenadas
        if (isNaN(lat) || isNaN(lng) || lat === 0 || lng === 0) {
          console.warn('⚠️ [MapConvocation] Coordenadas inválidas:', track);
          return null;
        }

        // Validar se está dentro de limites razoáveis (Brasil)
        if (lat < -35 || lat > 6 || lng < -75 || lng > -30) {
          console.warn('⚠️ [MapConvocation] Coordenadas fora dos limites do Brasil:', { lat, lng });
          return null;
        }

        console.log('✅ [MapConvocation] Adicionando marcador de caminhão:', { lat, lng, carga_id: track.carga_id });

        return (
          <Marker
            key={`track-${track.carga_id || track.id || index}`}
            position={[lat, lng]}
            icon={VehicleIcon}
          >
            <Popup>
              <strong>🚚 Posição do Caminhão</strong>
              <br />
              Carga ID: {track.carga_id ? track.carga_id.substring(0, 8) + '...' : 'N/A'}
              <br />
              Motorista: {track.motorista_nome || 'N/A'}
              <br />
              Telefone: {track.motorista_telefone || 'N/A'}
              <br />
              {track.data_envio && (
                <>
                  Última atualização: {new Date(track.data_envio).toLocaleString('pt-BR')}
                </>
              )}
            </Popup>
          </Marker>
        );
      })}

      {/* Marcadores de Destinatário (Local de Entrega) das Viagens Não Encerradas */}
      {trips && trips.length > 0 && trips.map((trip, index) => {
        // Verificar se a viagem tem coordenadas do destinatário
        const destinatarioLat = trip.destinatario?.lat || trip.destinatario_lat;
        const destinatarioLng = trip.destinatario?.lng || trip.destinatario_lng;

        return (
          <React.Fragment key={`trip-${trip.id || index}`}>
            {/* Marcador do Destinatário (Local de Entrega) com ícone padrão de localização */}
            {destinatarioLat && destinatarioLng && (
              <Marker
                position={[parseFloat(destinatarioLat), parseFloat(destinatarioLng)]}
              >
                <Popup>
                  <strong>Local de Entrega</strong>
                  <br />
                  Destinatário: {trip.destinatario?.nome_razao_social || trip.destinatario_nome || 'N/A'}
                  <br />
                  Motorista: {trip.motorista_nome || 'N/A'}
                  <br />
                  Veiculo: {trip.veiculo?.placa || 'N/A'}
                </Popup>
              </Marker>
            )}
          </React.Fragment>
        );
      })}
    </LeafletMap>
  );
};
